import React from 'react';
import { motion } from 'framer-motion';
import { bumblebeeSteps } from '../../data/deck';
const PATH = 'M 20 52 C 120 6, 200 6, 300 40 S 480 86, 580 40 S 760 0, 860 46';
const NODES = [{
  x: 20,
  y: 52
}, {
  x: 440,
  y: 62
}, {
  x: 860,
  y: 46
}];

/**
 * A quiet, elegant take on the Bumblebee Principle: a soft point of light
 * travels between three "flowers" — connect, gather, share.
 */
export function BumblebeePath() {
  return <figure className="relative" aria-label="The Bumblebee Principle" data-id="element-238" data-mp="1f1k2fjwne1vf">
      <svg viewBox="0 0 880 100" className="h-[70px] w-full sm:h-[90px]" aria-hidden="true" data-id="element-239" data-mp="1a420idh1smwx">
        <path d={PATH} fill="none" stroke="var(--brand)" strokeOpacity={0.25} strokeWidth={1.5} strokeDasharray="2 7" strokeLinecap="round" data-id="element-240" data-mp="160m4njcsyqla" />
        {NODES.map((node, i) => <g key={i} data-id="element-241" data-mp="3qrcww7hzvayv" data-mpi={i}>
            <motion.circle cx={node.x} cy={node.y} fill="none" stroke="var(--brand)" strokeWidth={1} initial={{
          r: 6,
          opacity: 0.5
        }} animate={{
          r: [6, 14, 6],
          opacity: [0.5, 0, 0.5]
        }} transition={{
          duration: 3.2,
          repeat: Infinity,
          delay: i * 1.1,
          ease: 'easeOut'
        }} data-id="element-242" data-mp="3qrwbbe8frh85" />
            <circle cx={node.x} cy={node.y} r={5} fill="var(--brand)" data-id="element-243" data-mp="17xxof2c1uabn" />
          </g>)}
        <circle r={4.5} fill="#E8A92E" style={{
        filter: 'drop-shadow(0 0 6px rgba(232,169,46,0.8))'
      }} data-id="element-244" data-mp="1cvg1n4x3nbpg">
          <animateMotion dur="14s" repeatCount="indefinite" path={PATH} keyPoints="0;1;0" keyTimes="0;0.5;1" calcMode="spline" keySplines="0.45 0 0.55 1;0.45 0 0.55 1" data-id="element-245" data-mp="y730ltj5n2o3" />
        </circle>
      </svg>
      <figcaption className="mt-1 grid grid-cols-3 text-[10.5px] font-bold uppercase tracking-[0.18em] text-[var(--fg)]/55" data-id="element-246" data-mp="t7qe59w73xm1">
        {bumblebeeSteps.map((step, i) => <span key={step} className={i === 0 ? 'text-left' : i === 1 ? 'text-center' : 'text-right'} data-id="element-247" data-mp="k7k7o7ywzxwd" data-mpi={i}>
            {step}
          </span>)}
      </figcaption>
    </figure>;
}